import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import CircularProgress from '@material-ui/core/CircularProgress'

import RadioButton from '../../common/RadioButton'

import * as Constants from '../../../helpers/Constants'
import * as configActions from '../../actions/Config'
import * as laundryRulesActions from '../../actions/LaundryRules'
import * as Strings from './strings'

class EditLaundryTypeModal extends Component {
  state = {
    type: Constants.LAUNDRY_ROOM,
    errorMessage: ''
  }

  componentWillReceiveProps(nextProps) {
    const { config, laundryRules, data } = this.props

    if (
      nextProps.config.editLaundryTypeModal.show &&
      !config.editLaundryTypeModal.show
    ) {
      this.setState({
        type: data.laundrySystem.laundryRule.laundryType,
        errorMessage: ''
      })
    }

    if (
      !nextProps.laundryRules.isUpdating &&
      nextProps.laundryRules.errorUpdating === null &&
      laundryRules.isUpdating
    ) {
      this.props.hideEditLaundryTypeModal()
      this.props.showSnackbar(Strings.default.LAUNDRY_TYPE_UPDATED)
    } else if (
      !nextProps.laundryRules.isUpdating &&
      nextProps.laundryRules.errorUpdating !== null &&
      laundryRules.isUpdating
    ) {
      this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
    }
  }

  render() {
    const { type, errorMessage } = this.state
    const { config, classes, laundryRules, user, data } = this.props

    return (
      <Dialog
        open={config.editLaundryTypeModal.show}
        aria-labelledby={'form-dialog-title'}
      >
        <DialogTitle id={'form-dialog-title'}>
          {Strings.default.LAUNDRY_TYPE}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {Strings.default.LAUNDRY_TYPE_INFO}
          </DialogContentText>
          {errorMessage === '' ? null : (
            <p style={{ fontSize: 12, color: '#e57373' }}>{errorMessage}</p>
          )}
          <RadioButton
            placeholder={Strings.default.LAUNDRY_ROOMS}
            checked={type === Constants.LAUNDRY_ROOM}
            style={{ marginTop: 15 }}
            onChange={() => this.setState({ type: Constants.LAUNDRY_ROOM })}
          />
          <RadioButton
            placeholder={Strings.default.LAUNDRY_MACHINES}
            checked={type === Constants.LAUNDRY_MACHINE}
            style={{ marginTop: 15 }}
            onChange={() => this.setState({ type: Constants.LAUNDRY_MACHINE })}
          />
        </DialogContent>
        {laundryRules.isUpdating ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 15
            }}
          >
            <CircularProgress
              style={{ color: '#289e64' }}
              thickness={6}
              size={20}
            />
          </div>
        ) : (
          <DialogActions>
            <Button
              onClick={() => this.props.hideEditLaundryTypeModal()}
              classes={{ label: classes.warningButtonText }}
            >
              {Strings.default.CANCEL}
            </Button>
            <Button
              onClick={() => {
                const postData = { laundryType: type }
                this.props.tryUpdateLaundryRules(
                  user.token,
                  data.community.id,
                  data.laundrySystem.laundryRule.id,
                  postData
                )
              }}
              classes={{ label: classes.successButtonText }}
            >
              {Strings.default.DONE}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }
}

const Styles = {
  successButtonText: {
    color: '#289e64'
  },
  warningButtonText: {
    color: '#e57373'
  }
}

function mapStateToProps({ data, user, config, laundryRules }) {
  return { data, user, config, laundryRules }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...laundryRulesActions },
    dispatch
  )
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(EditLaundryTypeModal)



// WEBPACK FOOTER //
// ./src/components/containers/EditLaundryTypeModal/index.js